import { collection, addDoc, onSnapshot, doc, getDoc, updateDoc, setDoc, arrayUnion, getDocs } from "firebase/firestore";
import { getAuth, signInWithEmailAndPassword, signOut, createUserWithEmailAndPassword } from "firebase/auth";
import { data, app } from "../firebase/firebese";

// دالة لإضافة صنف جديد إلى Firestore
export async function addMenuItem(item) {
  try {
    const docRef = await addDoc(collection(data, "menuItems"), item);
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error("خطأ أثناء الإضافة إلى Firestore:", error);
    return { success: false, error };
  }
}

// دالة للحصول على جميع الأصناف من Firestore في الوقت الفعلي
export function getMenuItemsRealtime(callback) {
  try {
    const unsubscribe = onSnapshot(collection(data, "menuItems"), (querySnapshot) => {
      const items = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      console.log("البيانات القادمة من فايربيز:", items);
      callback({ success: true, data: items });
    }, (error) => {
      console.error("خطأ أثناء جلب البيانات من Firestore:", error);
      callback({ success: false, error });
    });
    
    return unsubscribe; // لإلغاء الاشتراك لاحقاً
  } catch (error) {
    console.error("خطأ في إعداد onSnapshot:", error);
    callback({ success: false, error });
  }
}

// دالة لإرسال البيانات (مثل addMenuItem ولكن باسم مختلف)
export async function sendMenuItem(item) {
  try {
    const docRef = await addDoc(collection(data, "menuItems"), {
      ...item,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error("خطأ أثناء إرسال البيانات إلى Firestore:", error);
    return { success: false, error };
  }
}

// دالة لتسجيل الدخول بالبريد الإلكتروني وكلمة المرور
export async function loginUser(email, password) {
  const auth = getAuth(app);
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return { success: true, user: userCredential.user };
  } catch (error) {
    return { success: false, error: error.message };
  }
}

// دالة لتسجيل الخروج
export async function logoutUser() {
  const auth = getAuth(app);
  try {
    await signOut(auth);
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
}

// دالة لإنشاء مستخدم جديد وتخزين بياناته في كولكشن authentact
export async function registerUser(email, password, phone, name) {
  const auth = getAuth(app);
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    // إضافة بيانات المستخدم إلى كولكشن authentact
    await setDoc(doc(data, "authentact", userCredential.user.uid), {
      uid: userCredential.user.uid,
      email,
      phone,
      name: name || "",
      isAdmain: false,
      createdAt: new Date().toISOString(),
      actions: []
    });
    return { success: true, user: userCredential.user };
  } catch (error) {
    return { success: false, error: error.code || error.message };
  }
}

// دالة لإضافة action جديد إلى مصفوفة actions في وثيقة المستخدم
export const addUserAction = async (action) => {
  const user = getAuth().currentUser;
  if (!user) {
    return { success: false, error: "User not found" };
  }
  const docRef = doc(data, "authentact", user.uid);
  try {
    const userSnap = await getDoc(docRef);
    if (!userSnap.exists()) {
      // إذا لم تكن الوثيقة موجودة، أنشئها مع أول action
      await setDoc(docRef, {
        uid: user.uid,
        email: user.email || "",
        phone: user.phoneNumber || "",
        isAdmain: false,
        createdAt: new Date().toISOString(),
        actions: [action]
      });
      return { success: true };
    }
    // إذا كانت موجودة، أضف الـ action إلى المصفوفة
    await updateDoc(docRef, {
      actions: arrayUnion(action)
    });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// دالة لجلب جميع الطلبات (actions من نوع order) لكل المستخدمين
export const getAllOrders = async () => {
  const usersSnap = await getDocs(collection(data, "authentact"));
  let allOrders = [];
  usersSnap.forEach((doc) => {
    const userData = doc.data();
    if (Array.isArray(userData.actions)) {
      userData.actions.forEach((action) => {
        if (action.type === "order") {
          allOrders.push({
            ...action,
            userEmail: userData.email || "-",
            userId: userData.uid || doc.id,
            phone: userData.phone || "-", // ← تأكد أن هذا السطر موجود
          });
        }
      });
    }
  });
  return allOrders;
};

// دالة لحفظ سلة الشراء الخاصة بالمستخدم في Firestore
export async function saveUserCart(uid, cartArray) {
  try {
    await setDoc(doc(data, "carts", uid), {
      cart: cartArray,
      updatedAt: new Date().toISOString(),
    });
    return { success: true };
  } catch (error) {
    console.error("خطأ أثناء حفظ السلة في Firestore:", error);
    return { success: false, error };
  }
}

// دالة لجلب سلة الشراء الخاصة بالمستخدم من Firestore
export async function getUserCart(uid) {
  try {
    const docRef = doc(data, "carts", uid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return { success: true, cart: docSnap.data().cart || [] };
    } else {
      return { success: true, cart: [] };
    }
  } catch (error) {
    console.error("خطأ أثناء جلب السلة من Firestore:", error);
    return { success: false, error };
  }
}

// دالة الاستماع اللحظي لسلة المستخدم
export function listenToUserCart(uid, callback) {
  const cartDocRef = doc(data, "carts", uid);
  return onSnapshot(cartDocRef, (docSnap) => {
    if (docSnap.exists()) {
      callback({ success: true, cart: docSnap.data().cart || [] });
    } else {
      callback({ success: true, cart: [] });
    }
  }, (error) => {
    callback({ success: false, error });
  });
}

// دالة ترجمة أكواد أخطاء Firebase Auth إلى رسائل عربية واضحة
export function getAuthErrorMessage(errorCode) {
  switch (errorCode) {
    case "auth/email-already-in-use":
      return "البريد الإلكتروني مستخدم بالفعل.";
    case "auth/invalid-email":
      return "البريد الإلكتروني غير صالح.";
    case "auth/weak-password":
      return "كلمة المرور ضعيفة. يجب أن تكون 6 أحرف على الأقل.";
    case "auth/user-not-found":
      return "لا يوجد مستخدم بهذا البريد الإلكتروني.";
    case "auth/wrong-password":
      return "كلمة المرور غير صحيحة.";
    case "auth/too-many-requests":
      return "تم حظر المحاولة مؤقتاً بسبب محاولات متكررة. حاول لاحقاً.";
    case "auth/network-request-failed":
      return "فشل الاتصال بالإنترنت. تحقق من الشبكة وحاول مجدداً.";
    case "auth/internal-error":
      return "حدث خطأ داخلي. حاول مرة أخرى.";
    case "auth/missing-password":
      return "يرجى إدخال كلمة المرور.";
    default:
      return "حدث خطأ غير متوقع. حاول مرة أخرى.";
  }
}



// حذف طلب كامل من Firestore
export async function deleteOrderFromFirestore(order) {
  const userDocRef = doc(data, "authentact", order.userId);
  const userDoc = await getDoc(userDocRef);
  if (!userDoc.exists()) return;
  const actions = userDoc.data().actions || [];
  const filtered = actions.filter(a =>
    !(a.type === "order" && a.date === order.date && a.tableNumber === order.tableNumber && a.total === order.total)
  );
  await updateDoc(userDocRef, { actions: filtered });
}

// حذف منتج من طلب في Firestore
export async function deleteProductFromOrderInFirestore(order, productIdx) {
  const userDocRef = doc(data, "authentact", order.userId);
  const userDoc = await getDoc(userDocRef);
  if (!userDoc.exists()) return;
  const actions = userDoc.data().actions || [];
  const updatedActions = actions.map(a => {
    if (a.type === "order" && a.date === order.date && a.tableNumber === order.tableNumber && a.total === order.total) {
      const newItems = [...(a.items || [])];
      newItems.splice(productIdx, 1);
      return { ...a, items: newItems };
    }
    return a;
  });
  await updateDoc(userDocRef, { actions: updatedActions });
}

// تحديث ملاحظة منتج داخل طلب في Firestore
export async function updateProductNoteInOrder(order, itemIdx, note) {
  const userDocRef = doc(data, "authentact", order.userId);
  const userDoc = await getDoc(userDocRef);
  if (!userDoc.exists()) return;
  const actions = userDoc.data().actions || [];
  const updatedActions = actions.map(a => {
    if (a.type === "order" && a.date === order.date && a.tableNumber === order.tableNumber && a.total === order.total) {
      const newItems = [...(a.items || [])];
      if (newItems[itemIdx]) {
        newItems[itemIdx] = { ...newItems[itemIdx], note };
      }
      return { ...a, items: newItems };
    }
    return a;
  });
  await updateDoc(userDocRef, { actions: updatedActions });
}

// تحديث مصفوفة extras لمنتج داخل طلب في Firestore
export async function updateProductExtrasInOrder(order, itemIdx, extras) {
  const userDocRef = doc(data, "authentact", order.userId);
  const userDoc = await getDoc(userDocRef);
  if (!userDoc.exists()) return;
  const actions = userDoc.data().actions || [];
  const updatedActions = actions.map(a => {
    if (a.type === "order" && a.date === order.date && a.tableNumber === order.tableNumber && a.total === order.total) {
      const newItems = [...(a.items || [])];
      if (newItems[itemIdx]) {
        newItems[itemIdx] = { ...newItems[itemIdx], extras };
      }
      return { ...a, items: newItems };
    }
    return a;
  });
  await updateDoc(userDocRef, { actions: updatedActions });
}

// الاستماع اللحظي لجميع الطلبات
export function listenToAllOrders(callback) {
  return onSnapshot(collection(data, "authentact"), (snapshot) => {
    let allOrders = [];
    snapshot.forEach((doc) => {
      const userData = doc.data();
      if (Array.isArray(userData.actions)) {
        userData.actions.forEach((action) => {
          if (action.type === "order") {
            // إخفاء الطلبات المكتملة من لوحة تحكم الأدمن
            if (action.status !== "تم الإنجاز") {
              allOrders.push({
                ...action,
                userEmail: userData.email || "-",
                userId: userData.uid || doc.id,
                name: userData.name || "",
                phone: userData.phone || "-", // أضف رقم الهاتف هنا
              });
            }
          }
        });
      }
    });
    callback(allOrders);
  });
}

export async function updateOrderNoteInFirestore(order, note, status = null) {
  const userDocRef = doc(data, "authentact", order.userId);
  const userDoc = await getDoc(userDocRef);
  if (!userDoc.exists()) return;
  const actions = userDoc.data().actions || [];
  const updatedActions = actions.map(a => {
    if (a.type === "order" && a.date === order.date && a.tableNumber === order.tableNumber && a.total === order.total) {
      const updatedAction = { ...a, adminNote: note };
      if (status !== null) {
        updatedAction.status = status;
      }
      return updatedAction;
    }
    return a;
  });
  await updateDoc(userDocRef, { actions: updatedActions });
}

// دالة لحذف منتج من Firestore
export async function deleteMenuItem(productId) {
  try {
    const { deleteDoc } = await import("firebase/firestore");
    await deleteDoc(doc(data, "menuItems", productId));
    return { success: true };
  } catch (error) {
    console.error("خطأ أثناء حذف المنتج:", error);
    return { success: false, error };
  }
}

// دالة لتحديث منتج في Firestore
export async function updateMenuItem(productId, updatedData) {
  try {
    await updateDoc(doc(data, "menuItems", productId), {
      ...updatedData,
      updatedAt: new Date().toISOString()
    });
    return { success: true };
  } catch (error) {
    console.error("خطأ أثناء تحديث المنتج:", error);
    return { success: false, error };
  }
}

export async function fetchMenuItems(category = null) {
  try {
    const querySnapshot = await getDocs(collection(data, "menuItems"));
    let items = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // فلترة فقط لو التصنيف موجود ومش best-foods
    if (category && category !== "best-foods") {
      items = items.filter((item) => item.category === category);
    }
    

    return items;
  } catch (error) {
    console.error("خطأ أثناء جلب البيانات من Firestore:", error);
    return [];
  }
}

